import {notificationUtils} from 'features/notifications'
import type {TestWebhookResultVM} from '../types'
import './webhookNotifications.css'

function showWebhookSuccess(result: TestWebhookResultVM): void {
	notificationUtils.showSnack({
		title: 'Success',
		content: result.message,
		style: 'default'
	})
}

function showWebhookError(result: TestWebhookResultVM): void {
	const content = result.message || 'Failed to send test event'
	notificationUtils.showSnack({
		title: 'Error',
		content,
		style: 'attention'
	})
}

export function handleWebhookTestResponse(result: TestWebhookResultVM): void {
	if (result.success) {
		showWebhookSuccess(result)
	} else {
		showWebhookError(result)
	}
}